export default "__VITE_ASSET__BoQF5Cww__"